export default __webpack_public_path__ + "static/media/antiques_dark.a69252d0.png";